<template>
<Dialog v-model="visible" :width="640" :max-width="1280" setting @setting="$emit('setting')">

  <template slot="title">
    <span class="title">{{ $t('type.MOTION') }}</span>
  </template>

  <MotionChart :device="device" :endpoint="endpoint" :unit="$t('unit.times')"></MotionChart>

  <v-data-table :headers="headers" :items="items" :loading="loading" :footer-props="footers" :no-data-text="$t('history.no_data_available')" item-key="time" :items-per-page="5" calculate-widths disable-sort>
    <template v-slot:item.motionState="{ item }">
      <span class="font-weight-bold" :class="getClass(item.motionState)">{{ $t(`motion.${item.motionState}`) }}</span>
    </template>
  </v-data-table>

</Dialog>
</template>

<script>
import Dialog from '@/components/utils/dialog/Dialog'
import HistoryDialog from '@/components/history/HistoryDialog'
import MotionChart from '@/components/chart/MotionChart'

export default {
  name: 'MotionHistoryDialog',
  mixins: [HistoryDialog],
  components: {
    Dialog,
    MotionChart
  },
  computed: {
    headers() {
      return [{
        text: this.$t('history.time'),
        value: 'timeText',
      }, {
        text: this.$t('history.state'),
        value: 'motionState',
        align: 'center'
      }];
    }
  },
  methods: {
    getClass(state) {
      switch (state) {
        case 'DETECTED':
          return 'red--text';
        default:
          return 'grey--text';
      }
    }
  }
}
</script>
